module.exports = __webpack_public_path__ + "img/4.fda5d899.png";